import { Typography } from "@mui/material";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { LoginState } from "../LoginState";
import { DotsProgress } from "shared-ts-ui-progress";
import { LoginStrategy } from "./LoginStrategy";
import { useResolveLoginStrategy } from "./useResolveLoginStrategy";
import { LoginFormUsingPageSubmit } from "./LoginFormUsingPageSubmit";
import { LoginFormUsingApi } from "./LoginFormUsingApi";
import { LoginFormOnMobileWebView } from "./LoginFormOnMobileWebView";

export interface LoginFormProps {
  username?: string | null;
  loginState: LoginState;
  onLoginStateChange: (result: LoginState) => void;
  onRegisterNewUser: () => void;
  strategy?: LoginStrategy; // defaults to 'auto'
  returnUrl?: string; // defaults to current location
}

export const LoginForm: FC<LoginFormProps> = (props) => {
  const { username, loginState, onLoginStateChange, onRegisterNewUser } = props;
  const { t } = useTranslation("shared-ts-ui-identity");

  const strategy = useResolveLoginStrategy(props.strategy);
  console.log("LoginForm: loginState: " + loginState);
  console.log("LoginForm: strategy: " + strategy);

  return (
    <>
      {loginState === "CheckingAccess" && (
        <Typography align={"center"}>
          {t("Checking Access")}
          <DotsProgress />
        </Typography>
      )}
      {loginState === "LoadingUser" && (
        <Typography align={"center"}>
          {t("Checking Access")}
          <DotsProgress />
        </Typography>
      )}
      {loginState.startsWith("Unauthorized") && strategy === "pageSubmit" && (
        <LoginFormUsingPageSubmit
          username={username}
          strategy={strategy}
          onRegisterNewUser={onRegisterNewUser}
        />
      )}
      {loginState.startsWith("Unauthorized") && strategy === "api" && (
        <LoginFormUsingApi
          username={username}
          loginState={loginState}
          strategy={strategy}
          onLoginStateChange={onLoginStateChange}
          onRegisterNewUser={onRegisterNewUser}
        />
      )}
      {loginState.startsWith("Unauthorized") &&
        strategy === "mobileWebView" && (
          <LoginFormOnMobileWebView
            username={username}
            strategy={strategy}
            onRegisterNewUser={onRegisterNewUser}
          />
        )}
    </>
  );
};
